/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlSupplementalFormStatus = {
    Created: 'CREATED',
    AccessedForm: 'ACCESSED_FORM',
    PartiallyCompleted: 'PARTIALLY_COMPLETED',
    Submitted: 'SUBMITTED',
    Invalidated: 'INVALIDATED',
    Expired: 'EXPIRED',
    Outdated: 'OUTDATED'
} as const;
export type ControlSupplementalFormStatus = typeof ControlSupplementalFormStatus[keyof typeof ControlSupplementalFormStatus];


export function ControlSupplementalFormStatusFromJSON(json: any): ControlSupplementalFormStatus {
    return ControlSupplementalFormStatusFromJSONTyped(json, false);
}

export function ControlSupplementalFormStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSupplementalFormStatus {
    return json as ControlSupplementalFormStatus;
}

export function ControlSupplementalFormStatusToJSON(value?: ControlSupplementalFormStatus | null): any {
    return value as any;
}

